function view (path) {
  return () => import(/* webpackChunkName: 'shared-v1' */ '@/views/shared/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const RShared = [
  {
    path: '',
    name: 'shared.redirect',
    authorizedRole: 'shared',
    redirect: { name: 'shared.login' }
  },
  {
    path: '/sign-in',
    component: view('SignIn'),
    name: 'shared.login',
    authorizedRole: 'shared',
    meta: {
      layout: 'auth'
    }
  },
  {
    path: '/auth/:provider/callback',
    component: view('SingleSignOn.vue'),
    name: 'shared.sso',
    authorizedRole: 'shared',
    meta: {
      layout: 'sso'
    }
  },
  {
    path: '*',
    component: view('404.vue'),
    name: 'shared.page-not-found',
    authorizedRole: 'shared',
    meta: {
      layout: 'auth'
    }
  }
]

const RSharedPrivate = [
  {
    path: '/account/settings',
    component: view('account-settings/Base'),
    name: 'shared.account.settings',
    meta: {
      breadcrumb: [
        {
          text: 'Account'
        },
        {
          text: 'Settings',
          active: true
        }
      ]
    }
  },
  {
    path: '/account/change-user',
    component: view('ChangeUser'),
    name: 'shared.account.change-user',
    meta: {
      breadcrumb: [
        {
          text: 'Account'
        },
        {
          text: 'Settings',
          active: true
        }
      ]
    }
  }
]

export default RShared.concat(
  RSharedPrivate
)
